<template>
  <modal v-if="showModal" @close="$emit('closeModal')">
    <template slot="header">
      <h4 class="modal-title">{{ title }}</h4>
      <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="$emit('closeModal')">
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <select-input
          v-model="parent.activity_id"
          :appendToBody="false"
          deselect-label="Can't remove this value"
          :track-by="'id'"
          label="Activity"
          placeholder="Select Activity"
          :options="activities"
          :allow-empty="false"
          :error="apiValidationErrors.activity_id">
      </select-input>
      <select-input
          v-model="parent.labourer_id"
          label=""
          :options="labourers"
          :errors="apiValidationErrors.labourer_id"
          :track-by="'labourer_number'"
          :name="'name'"
          :taggable="false"
          :reduce-to-value="false"
          @selecting="changeLabourer($event)"
          @removing="updatePrevious($event)"
          @search="labourerFind($event)"
      />
      <md-field>
        <label>Start Date</label>
        <md-input v-model="parent.start_date"></md-input>
      </md-field>
      <validation-error :errors="apiValidationErrors.start_date"/>
    </template>

    <template slot="footer">
      <md-button class="md-simple" @click="add">Add Assignment</md-button>
      <md-button
          class="md-danger md-simple"
          @click="$emit('closeModal')">Close
      </md-button>
    </template>
  </modal>
</template>

<script>
import { Modal } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '@/components/Inputs/SelectInput.vue';
import ValidationError from '@/components/ValidationError.vue';

export default {
    name: 'AddActivityLabourerWorkplaceModal',
    components: { SelectInput, Modal, ValidationError },
    mixins: [formMixin],
    props: {
        title: {
            type: String, default: 'Add Activity'
        },
        workplace: {
            type: Object
        },
        showModal: {
            type: Boolean, default: false
        },
        multiple: {
            type: Boolean, default: false
        },
        model: {
            type: String, default: ''
        },
        modelType: {
            type: String, default: 'activityLabourerWorkplaces/list'
        }
    },
    data () {
        return {
            selected: [],
            labourers: [],
            activities: [],
            workplaces: [],
            parent: {}
        };
    },
    created () {
        this.fetchData();
        this.resetParent();
    },
    methods: {

        async add () {
            try {
                this.parent.workplace_id = this.workplace.id;
                await this.$store.dispatch('activityLabourerWorkplaces/add', this.parent);
                this.parent = this.$store.getters['activityLabourerWorkplaces/get'];
                this.notifySuccess('Parent added successfully.');
                this.$emit('addParents', this.parent);
                this.resetParent();
            } catch (e) {
                this.notifyException(e);
            }
        },
        async fetchData () {
            const activitiesParam = {
                filter: { hasTariff: 'true' }
            };
            await this.$store.dispatch('activities/list', activitiesParam);
            this.activities = this.$store.getters['activities/list'];

            this.laboures = [];
        },
        resetParent () {
            this.parent = {
                workplace_id: this.workplace.id,
                type: 'activityLabourerWorkplaces',
                labourer_id: '',
                activity_id: '',
                start_date: ''
            };
        },

        changeLabourer (value) {
            this.$emit('change:labourer', value);
        },
        updatePrevious (_) {
            this.$emit('remove-labourer', null);
        },
        labourerFind (query) {
            this.$emit('labourer:find', query);
        },
    },
};
</script>

<style scoped>

</style>
